import Vue from 'vue'
import Vuex from 'vuex'

import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

import products from './modules/products'
import categories from './modules/categories'
import properties from './modules/properties'
import cart from './modules/cart'
import shappy from './modules/shappy'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    params: {
      publicToken: '',
      shappyCustomToken: '',
      appId: '',
      channelId: '',
      primaryColor: '',
      secondaryColor: '',
      member: 0,
      language: 'th'
    }
  },
  mutations,
  actions,
  getters,
  modules: {
    products,
    categories,
    properties,
    cart,
    shappy
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js